import React, { useEffect, useState } from "react";
import classes from "./ExpirationCountdown.module.css";

const ExpirationCountdown = ({ amount, targetDate }) => {


 const calculateTimeLeft = () => {
  const now = new Date();
  const difference = targetDate - now;

  if (difference <= 0) {
    return { hours: 0, minutes: 0, seconds: 0, totalMs: 0 };
  }

  const hours = Math.floor(difference / (1000 * 60 * 60));
  const minutes = Math.floor((difference / (1000 * 60)) % 60);
  const seconds = Math.floor((difference / 1000) % 60);

  return { hours, minutes, seconds, totalMs: difference };
};

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [slotData, setSlotData] = useState(null);

  useEffect(() => {
  const timer = setInterval(() => {
    setTimeLeft(calculateTimeLeft());
  }, 1000); // update every second

  return () => clearInterval(timer);
}, []);

  return (
    <div className={`${classes.wrapper}`}>
      <div
        className={`row flex-column flex-md-row align-items-center justify-content-between gap-4 ${classes.contentBox}`}
      >
        {/* Left Section */}
        <div className="col-12 col-md-6 text-center text-md-start">
         
            <>
              <h3 className="text-white mb-2">
                Pay {amount} in 72 hours to claim your funded account
              </h3>
            </>
        </div>

        {/* Middle Countdown */}
        <div
          className={`col-12 col-md-4 d-flex justify-content-center ${classes.outerTimerBox}`}
        >
          <div className="d-flex justify-content-center gap-3">
            <div
              className={`${classes.timerWrapper} d-flex flex-column justify-content-center gap-2`}
            >
              <div className={classes.timerBox}>
                <span className={classes.timerValue}>{timeLeft.hours}</span>
              </div>
              <span className={classes.timerLabel}>HOURS</span>
            </div>

            <div
              className={`${classes.timerWrapper} d-flex flex-column justify-content-center gap-2`}
            >
              <div className={classes.timerBox}>
                <span className={classes.timerValue}>{timeLeft.minutes}</span>
              </div>
              <span className={classes.timerLabel}>MINUTES</span>
            </div>

            <div
              className={`${classes.timerWrapper} d-flex flex-column justify-content-center gap-2`}
            >
              <div className={classes.timerBox}>
                <span className={classes.timerValue}>{timeLeft.seconds}</span>
              </div>
              <span className={classes.timerLabel}>SECONDS</span>
            </div>
          </div>
        </div>

       
      </div>
    </div>
  );
};

export default ExpirationCountdown;
